// 2_components/page_title.js
// On PL/SK category, manufacturer-detail and static pages, syncs the first <h1>
// with the document title (minus any " - Natima" / " | Natima" suffix) when they differ.

export function init() {
	if (window.NAT.lang !== "pl" && window.NAT.lang !== "sk") return;

	if (
		document.body.classList.contains("type-category") ||
		document.body.classList.contains("type-manufacturer-detail") ||
		document.body.classList.contains("type-page")
	) {
		const h1 = $("h1").first();
		let title = document.title;
		// If the first h1 isn't equal to the page title,
		if (h1.text() !== title) {
			// Change h1 to page title but remove " - Natima" or " | Natima" if it's in there
			title = title.replace(/ - Natima| - natima| \| Natima| \| natima/g, "");
			h1.text(title);
		}
	}
}
